import { useMe } from 'store/userStore';
import { UserSelect, UserSelectProps } from './UserSelect';
import React from 'react';
import { can } from 'helpers/userUtils';
import { Permission } from 'api/user';
import { TherapyStatus } from 'api/therapy';

interface ClientSelectProps extends Omit<UserSelectProps, 'filters'> {}

export const ClientSelect = (props: ClientSelectProps) => {
  const me = useMe();

  // TODO maybe revise this later
  // a better idea might be expose an endpoint as a prop from UserSelect and re-use /chat/users endpoint, which does the
  // filtering internally
  const filters = React.useMemo(
    () =>
      can(me, Permission.THERAPY_ALL)
        ? {
            query: {
              therapies: {
                some: {
                  therapistId: me?.userId,
                  status: TherapyStatus.ACTIVE,
                },
              },
            },
          }
        : {
            query: {
              coachId: me?.userId,
            },
          },
    [me]
  );

  return <UserSelect {...props} filters={filters} />;
};
